<template>
  <main class="MdfeDetails">
    <!-- Sub Header -->
    <TheSubHeader
      icon="package-delivery-alt"
      title="Detalhes da MDFe"
      :actions="['back']"
      organizer-gap="1rem"
    />
    <!--Content -->
    <section class="MdfeDetails__Container">
      <div class="MdfeDetails__Content">
        <div class="MdfeDetails__Form">
          <MdfeDetailsForm
            ref="mdfeDetailsForm"
            @save="handlerSave"
          />
        </div>
      </div>
    </section>
    <CteManagementModal
      ref="modal"
      title="Edição de MDFe"
      @cancel="cancel"
      @save="save"
    />
  </main>
</template>
<script>
import { TheSubHeader } from '@/components/organisms'
import MdfeDetailsForm from  './Form/MdfeDetailsForm.vue'
import CteManagementModal from '../CteManagementModal.vue'

export default {
  name: 'MdfeDetailsEdit',
  components: {
    TheSubHeader,
    MdfeDetailsForm,
    CteManagementModal
  },
  methods: {
    //Handlers
    handlerSave() {
      this.$refs.modal.open()
    },

    cancel() {
      this.$refs.mdfeDetailsForm.setInitialForm()
    },

    save() {
      this.$refs.mdfeDetailsForm.putMdfeDetails()
    },
  }
}
</script>
<style lang="scss" scoped>
.MdfeDetails {
  &__subHeaderTab {
    display: grid;
    grid-column-gap: 1rem;
    align-items: end;
    width: 100%;
  }

  &__Container{
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 1180px) 1fr;
    grid-template-areas: ". main .";
    grid-column-gap: 1rem;
  }

  &__Content {
    grid-area: main;
    margin-bottom: 50px;
  }

  &__Form {
    margin-bottom: 50px;
  }
}
</style>